import TransactionList from 'common/pages/transactions/TransactionList.tsx'

export const TransactionAdvList = (props: any) => <TransactionList {...props} admin={false} />